var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container } from './Button.styles';
import Spinner from '../Spinner/Spinner';
const Button = (_a) => {
    var { children, variant, color, size, fullWidth, type, disabled, loading } = _a, props = __rest(_a, ["children", "variant", "color", "size", "fullWidth", "type", "disabled", "loading"]);
    return (_jsxs(Container, Object.assign({ type: type, fullWidth: fullWidth, size: size, color: color, variant: variant, disabled: loading || disabled, whileHover: {
            scale: 1.01,
            transition: { duration: 0.3 }
        }, whileTap: { scale: 0.98 } }, props, { children: [children, loading && _jsx(Spinner, {}, void 0)] }), void 0));
};
export { Button };
//# sourceMappingURL=Button.js.map